// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ybnr","right":"styles_right__3TI4-"};